import { SystemPage, SystemSection } from "./SystemPage.js";

/**
 * `/_cleanup` — stub. The future home for the *scary* half of orchestration:
 * removing state that's no longer declared in `datawiki-config` — orphaned repo
 * checkouts, stale worktrees, dead caches. Deletes destroy data, so this is
 * deliberately manual and not yet built (the orchestrator only adds; see
 * orchestrator.ts / docs/ops).
 */
export function CleanupView() {
  return (
    <SystemPage
      title="Cleanup"
      lead="Remove state no longer declared in datawiki-config (orphaned checkouts, stale worktrees, dead caches)."
    >
      <SystemSection title="Not built yet">
        <p className="dw-muted">
          Deleting is the scary half of orchestration — it destroys data — so it's
          manual and not yet implemented. The orchestrator only <em>adds</em>
          (clones declared repos on save); orphans are surfaced on{" "}
          <a href="/_status">status</a> for now.
        </p>
      </SystemSection>
    </SystemPage>
  );
}
